import actionTypes from "./actionTypes";
import initialState from "./initialState";

const projectReducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.PROJECT :{ 
            return{
            ...state,
            project:!state.project
        }}
        default:{
            return state;
        }
    }
}

export default projectReducer;